module.exports = __webpack_public_path__ + "img/s8sLogo1.02edc812.png";